import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { UserModel } from '../../../models/user.model';
import { InitialsPipe } from '../../../pipes/initials.pipe';
import { MomentPipe } from '../../../pipes/moment.pipe';
import { AppState } from '../../../state/appstate';
import { BtnIconComponent } from '../../components/buttons/btn-icon/btn-icon.component';

@Component({
  selector: 'app-dlg-view-profile',
  standalone: true,
  imports: [MomentPipe, BtnIconComponent, InitialsPipe],
  templateUrl: './dlg-view-profile.component.html',
  styleUrl: './dlg-view-profile.component.css',
})
export class DlgViewProfileComponent implements OnInit, OnDestroy {
  store: Store<AppState> = inject(Store<AppState>);
  readonly data = inject<any>(MAT_DIALOG_DATA);
  readonly dialogRef = inject(MatDialogRef<DlgViewProfileComponent>);

  user: UserModel | null = null;
  inProgress$: Observable<boolean> = new Observable<boolean>();

  title: string = 'My Group Details';
  description: string = `Your profile as seem by group members`;
  action: string = 'Sync From Profile';

  exit$: Subject<void> = new Subject();

  constructor() {
    this.title = this.data?.title ?? this.title;
    this.description = this.data?.description ?? this.description;
  }
  ngOnDestroy(): void {
    document.body.style.overflow = 'auto';
    this.exit$.next();
    this.exit$.complete();
  }

  ngOnInit(): void {
    document.body.style.overflow = 'hidden';
    if (!this.data?.user) {
      this.store
        .select((state) => state.user.user)
        .pipe(takeUntil(this.exit$))
        .subscribe((user) => {
          this.user = user;
        });
    }

    this.inProgress$ = this.store
      .select((state) => state.user.loading)
      .pipe(takeUntil(this.exit$));
  }

  get viewableUser(): UserModel | null {
    return this.data?.user ?? this.user;
  }

  get canViewDob(): boolean {
    const targetUser = this.viewableUser;
    if (!targetUser) return false;
    if (!this.data?.user) return true; // Owner viewing own profile
    return targetUser.isDobViewable !== false;
  }

  onSyncProfile(): void {
    // Implement sync profile logic here
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
